// extracted by mini-css-extract-plugin
export default {"main":"MainContainer_main__ICHYP","main_withHeader":"MainContainer_main_withHeader__lw20y"};